import { createSelector } from "reselect"
import { chain, pickBy, map, isEmpty } from "lodash"
import { getAllItems, getOrderedCategoryItems, getFavoriteFactors } from "./items"
import { getPerformanceHistory } from "./performance"
import { COLORS, ANALYZE_FACTORS_TAKE, MANDATORY_PERFORMANCE_METRICS } from "helpers/analyzeConstants"
import { computePerformanceData, computeDisplayCategories, computeNonZerosKeys } from "helpers/analyze"
import { getFactorCategoryId } from "."

const EMPTY_ARRAY = []

const getData = createSelector(
  [getAllItems, getPerformanceHistory],
  computePerformanceData,
)

const getOverrideKeys = createSelector(
  [getFavoriteFactors, getFactorCategoryId],
  (favoriteFactors, factorCategoryId) => ({
    ...MANDATORY_PERFORMANCE_METRICS,
    ...favoriteFactors,
    [`${factorCategoryId}_total`]: true,
  }),
)
const getNonZerosKeys = createSelector(
  [getData, getOverrideKeys],
  computeNonZerosKeys,
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  (items, keys) => chain(items)
    .filter(item => keys[item.id])
    .take(ANALYZE_FACTORS_TAKE + 1) // 1 category total item + X items
    .map((item, index) => {
      return {
        ...item,
        color: item.color || COLORS[index - 1], // Ignore the "total" item color
      }
    })
    .value(),
)

export const getDisplayCategories = createSelector(
  [getAllItems, getNonZerosKeys],
  computeDisplayCategories,
)

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys, getCategoryItemsSubset],
  (data, keys, items) => isEmpty(items) ? EMPTY_ARRAY : map(data, item => pickBy(item, (_, key) => keys[key])),
)
